"use client";

import LinksGrid from "@/components/LinksGrid";
import { useTranslations } from "next-intl";

export default function CountryNeighborsClient({
  items,
  formattedCountry,
}) {
  const t = useTranslations("flight");
  const title = t("countryNearbyCountriesTitle", {
    country: formattedCountry,
  });

  return (
    <section className="container mx-auto w-full">
      <LinksGrid
        title={title}
        items={items}
        gridCols={{
          mobile: 2,
          tablet: 3,
          desktop: 3,
          large: 4,
        }}
        shownImage={false}
      />
    </section>
  );
}
